<template>
    <div :class="outerContainerClasses" v-on="$listeners">
        <label v-if="hasLabel" :class="labelClasses" :for="id">
            {{ label }}
        </label>
        <div v-bind:class="innerContainerClasses">
            <slot></slot>
        </div>
        <div>
            <p class="help" v-if="getHelpText" v-html="getHelpText" />
        </div>
        <template v-if="hasError">
            <div
                v-for="(err, index) in error"
                :key="index"
                :class="errorClasses"
            >
                {{ err }}
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "FormField",

    props: {
        label: {},
        helpText: String,
        error: Array,
        id: String,
        isBootstrap: {
            type: Boolean,
            default: false,
        },
        isBulma: {
            type: Boolean,
            default: true,
        },
        hasLabel: {
            type: Boolean,
            default: true,
        },
        formType: String,

        outerContainerClass: [String, Array],
        innerContainerClass: [String, Array],
        labelClass: [String, Array],
        errorClass: [String, Array],
        iconRight: Boolean,
        iconLeft: Boolean,

        // Horizontal form
        labelWidth: {
            type: Number,
            default: 3,
        },
        inputSize: String,
        inputWidth: {
            type: Number,
            default: 9,
        },
        inputOffset: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        getHelpText() {
            if (this.helpText !== undefined) {
                return this.helpText || "&nbsp;";
            }

            return undefined;
        },
        hasError() {
            return this.error !== undefined;
        },

        outerContainerClasses() {
            const classes = Array.isArray(this.outerContainerClass)
                ? this.outerContainerClass
                : [this.outerContainerClass];

            if (this.isBootstrap) {
                classes.push("form-group");
                if (this.hasError) {
                    classes.push("has-error", "has-feedback");
                }
            }
            if (this.isBulma) {
                classes.push("field");
                if (this.formType == "horizontal") {
                    classes.push("is-horizontal");
                }
            }

            return classes.join(" ");
        },

        labelClasses() {
            const classes = Array.isArray(this.labelClass)
                ? this.labelClass
                : [this.labelClass];

            if (this.isBootstrap) {
                classes.push("control-label");
            }
            if (this.isBulma) {
                classes.push("label");
                if (this.inputSize) {
                    classes.push("is-" + this.inputSize);
                }
            }

            if (this.formType == "horizontal" && this.labelWidth > 0) {
                classes.push("col-sm-" + this.labelWidth);
            }

            return classes.join(" ");
        },

        innerContainerClasses() {
            const classes = Array.isArray(this.innerContainerClass)
                ? this.innerContainerClass
                : [this.innerContainerClass];

            if (this.isBulma) {
                classes.push("control");

                if (this.iconRight) {
                    classes.push("has-icons-right");
                }

                if (this.iconLeft) {
                    classes.push("has-icons-left");
                }
            }

            if (this.formType == "horizontal" && this.inputWidth > 0) {
                classes.push("col-sm-" + this.inputWidth);
                if (this.inputOffset > 0) {
                    classes.push("col-sm-offset-" + this.inputOffset);
                } else if (!this.hasLabel) {
                    classes.push("col-sm-offset-" + (12 - this.inputWidth));
                }
            }

            return classes.join(" ");
        },

        errorClasses() {
            const classes = Array.isArray(this.errorClass)
                ? this.errorClass
                : [this.errorClass];

            if (this.isBootstrap) {
                classes.push("help-block");
            }
            if (this.isBulma) {
                classes.push("help");
                if (this.hasError) {
                    classes.push("is-danger");
                }
            }

            if (this.formType == "horizontal" && this.inputWidth > 0) {
                classes.push("col-sm-" + this.inputWidth);
                if (this.inputOffset > 0) {
                    classes.push("col-sm-offset-" + this.inputOffset);
                } else {
                    classes.push("col-sm-offset-" + (12 - this.inputWidth));
                }
            }

            return classes.join(" ");
        },
    },
};
</script>
